import React, { useState, useEffect } from "react";
import { Button, Modal, Radio, RadioGroup, TextInput } from "@opendate-app/setlist";

const styles = {
  body: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  radios: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
};

const SaveAsBlueprintModal = ({
  isOpen,
  onClose,
  template,
  copiedFromBlueprint,
  teamId,
  createBlueprint,
  updateBlueprint,
}) => {
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const canUpdateExisting = copiedFromBlueprint && copiedFromBlueprint.team_id === teamId;
  const [mode, setMode] = useState(canUpdateExisting ? "update" : "new");

  useEffect(() => {
    if (isOpen) {
      setMode(canUpdateExisting ? "update" : "new");
    }
  }, [isOpen, canUpdateExisting]);

  const handleSave = () => {
    setIsLoading(true);

    if (mode === "new") {
      createBlueprint(name, template, (result) => {
        setIsLoading(false);
        if (result) {
          setName("");
          onClose();
        }
      });
    } else if (mode === "update" && canUpdateExisting) {
      updateBlueprint(copiedFromBlueprint.id, template, (result) => {
        setIsLoading(false);
        if (result) {
          onClose();
        }
      });
    }
  };

  const handleClose = () => {
    setName("");
    setMode("new");
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      width={480}
      title="Save as Blueprint"
      description="Save this template as a reusable blueprint for your team."
      closeOnBackdrop={!isLoading}
      closeOnEsc={!isLoading}
      showClose={!isLoading}
      footer={(
        <>
          <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isLoading || (mode === "new" && !name.trim())}
          >
            {isLoading ? "Saving..." : mode === "new" ? "Create Blueprint" : "Update Blueprint"}
          </Button>
        </>
      )}
    >
      <div style={styles.body}>
        {canUpdateExisting && (
          <div role="radiogroup" aria-label="Blueprint" style={styles.radios}>
            <RadioGroup name="blueprintMode" value={mode} onChange={setMode} disabled={isLoading}>
              <Radio value="update" label={<>Update existing blueprint: <strong>{copiedFromBlueprint.name}</strong></>} />
              <Radio value="new" label="Save as new blueprint" />
            </RadioGroup>
          </div>
        )}

        {mode === "new" && (
          <TextInput
            label="Blueprint Name"
            id="blueprintName"
            placeholder="Enter blueprint name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={isLoading}
            autoFocus
          />
        )}
      </div>
    </Modal>
  );
};

export default SaveAsBlueprintModal;
